import { withTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import {withShortcuts} from '../../../containers/Shortcuts'
import { setPlacementMode, toggleGridHide } from '../../../store/actions/boards'
// import {
//   // createColorBlock,
//   createTextBlock
// } from '../../../store/actions/blocks'
import { redo, undo } from '../../../store/actions/history'
import { selectBlocks } from '../../../store/actions/selectedBlocks'
import { switchToggle } from '../../../store/actions/toggles'
import { uploadFilesToQueue } from '../../../store/actions/upload'
import { userSelector } from '../../../store/selectors/baseSelectors'
import {
  currentBoardSelector,
  placementModeSelector,
  queueLengthSelector
} from '../../../store/selectors/selectors'

const EditControlsContainer = compose(
  connect(
    state => {
      const user = userSelector(state)
      return {
        anon: !user || user.isEmpty || user.isAnonymous,
        board: currentBoardSelector(state),
        queueLength: queueLengthSelector(state),
        placementMode: placementModeSelector(state)
      }
    },
    {
      uploadFilesToQueue,
      switchToggle,
      setPlacementMode,
      selectAll: () => selectBlocks('all'),
      undo,
      redo,
      toggleGridHide
    },
    (stateProps, dispatchProps, ownProps) => ({
      ...stateProps,
      ...dispatchProps,
      ...ownProps,
      togglePlacementMode: mode =>
        dispatchProps.setPlacementMode(
          stateProps.placementMode === mode ? null : mode
        ),
      uploadFilesToQueue: event => {
        dispatchProps.uploadFilesToQueue(event.target.files, stateProps.board)
        event.target.value = ''
      }
    })
  ),
  withShortcuts('BOARD', props => (action, event) => {
    switch (action) {
      case 'SELECT_ALL':
        props.selectAll()
        event.preventDefault()
        break
      case 'PLACE_TEXT':
        props.togglePlacementMode('text')
        break
      case 'PLACE_COLOR':
        props.togglePlacementMode('color')
        break
      case 'CANCEL_PLACEMENT':
        props.togglePlacementMode(null)
        break
      case 'TOGGLE_HIDE_GRID':
        props.toggleGridHide(null)
        break
      case 'UNDO':
        props.undo()
        event.preventDefault()
        break
      case 'REDO':
        props.redo()
        break
      default:
    }
  }),
  withTranslation()
)

export default EditControlsContainer
